import { useMemo } from 'react';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import clsx from 'clsx';

import BlockItem, { type Block } from '.';

import styles from './ContentBlock.module.css';

interface ContentBlockRecord extends CdaStructuredTextRecord {
  variant: '1_col' | '2_col' | '3_col' | 'top_row_col';
  columnWidths: Record<string, number>;
  column1: Block[];
  column2: Block[];
  column3: Block[];
  isContained?: boolean;
}

export default function ContentBlock({ variant = '3_col', isContained, columnWidths, ...rest }: ContentBlockRecord) {
  const columns = useMemo(() => {
    const numberOfColumns = parseInt(variant[0], 10) || 3;
    return Array(numberOfColumns)
      .fill(null)
      .map((_, index) => (
        <div
          key={index}
          className={styles.column}
          style={
            {
              '--w': `${columnWidths[`col${index + 1}`] || '50'}%`,
              '--m': `${columnWidths[`col${index + 1}-margin`] || '0'}%`,
              display: columnWidths[`col${index + 1}-grid`] ? 'grid' : 'flex',
            } as object
          }
        >
          {`column${index + 1}` in rest && (rest[`column${index + 1}`] as Block[])?.map(BlockItem)}
        </div>
      ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant, columnWidths]);

  return <div className={clsx(styles.content, isContained && styles.contained)}>{columns}</div>;
}
